import React, { PropsWithChildren } from "react";
import { ReadonlyContext } from "utilities/contexts/readonly/use-readonly-context";

interface ReadonlyContextProviderProps {
    isReadonly: boolean;
}

export const ReadonlyContextProvider: React.FC<
    PropsWithChildren<ReadonlyContextProviderProps>
> = ({ children, isReadonly }) => (
    <ReadonlyContext.Provider value={isReadonly}>
        {children}
    </ReadonlyContext.Provider>
);
